export namespace Routes {
  export const Home = '/'
  // auth routes
  export const Login = '/login'
  export const Register = '/register'
  // app routes
  export const Dashboard = '/dashboard'
  export const Settings = '/settings'
  export const Users = '/users'
  // leads routes
  export const LeadsList = '/leads'
  export const LeadDetails = (id: string) => `/leads/${id}`
  // partners routes
  export const Partners = '/partners'
  export const PartnerDetails = (slug: string) => `/partners/${slug}`
  export const PartnerDetailsLogs = (slug: string) => `/partners/${slug}/events`
  export const PartnerDetailsLeads = (slug: string) => `/partners/${slug}/leads`
  export const PartnerDetailsSettings = (slug: string) => `/partners/${slug}/settings`
}
